import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {CoreDI, IEventManagerWithAsync, inject, injectable, ModuleInitPhase, System} from '@gongxigames/framework/core';
import {ILoadingScreenView} from '@gongxigames/framework/slot/modules/loadingScreen/ILoadingScreenView';
import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export type LoadingScreenEvents = GlobalEventsMap & {
    'LoadingScreen.START_BUTTON_PRESSED': void;
};

@injectable()
export class LoadingScreenModule extends Module<ILoadingScreenView, LoadingScreenEvents> {
    public static readonly NAME = 'LoadingScreenModule';
    public static readonly VIEW = 'LoadingScreenView';
    public static readonly initPhase: ModuleInitPhase = 'initial';

    @inject(CoreDI.IEventManagerWithAsync)
    protected _eventManager!: IEventManagerWithAsync;

    @inject(CoreDI.System)
    protected _system!: System;

    private playResolve?: () => void;
    protected gameInitialized = false;

    public init(): void {
        this.setView(LoadingScreenModule.VIEW);

        strictUiEmitter.on('General.Game.PLAY_INTRO', this.play.bind(this), {owner: this});
        this.on('General.Game.INITIALIZED', this.onGameInitialized.bind(this));
        this.on('General.ResourcesLoading.PROGRESS', this.update.bind(this));
        this.on('General.Game.ENABLE_FIRST_INTERACTION', this.onEnableFirstInteraction.bind(this));
        this.onView('LoadingScreen.START_BUTTON_PRESSED', this.onStartButtonClicked.bind(this));
        this.gameInitialized = false;
    }

    private unsubscribeAll(): void {
        strictUiEmitter.offAllByOwner(this);
        this.off('General.Game.INITIALIZED');
        this.off('General.ResourcesLoading.PROGRESS');
    }

    private play(): Promise<void> {
        return new Promise<void>(resolve => {
            this.playResolve = resolve;
            this.view.start();
        });
    }

    private update(_id: string, progress: number): void {
        this.view.updateProgress(progress);
    }

    private onGameInitialized(): void {
        this.view.loadingComplete(Boolean(this.settings.get('showOddsUpfront')));
        this.gameInitialized = true;

        if (this.settings.get('showOddsUpfront')) {
            this.playResolve?.();
        }
    }

    private onEnableFirstInteraction(_id: string, show: boolean): void {
        this.view.enableFirstInteraction(show);
    }

    private onStartButtonClicked(): void {
        if (!this.gameInitialized) {
            return;
        }

        this.unsubscribeAll();
        this.eventManager.emit('General.Game.START_GAME');
        this.eventManager.emit('General.Game.FIRST_INTERACTION');

        this.playResolve?.();
    }
}
